import mitt, { Emitter } from 'mitt';

type Events = {
  node_detected: string;
  connectedChange: boolean;
  'sync ends': unknown;
  'sync sensitive data ends': unknown;
  'receive invoice': unknown;
  'pay now': unknown;
  'paynow status': unknown;
};
export const eventBus: Emitter<Events> = mitt<Events>();
